export const statuses = {
  awaiting: 'Afventer godkendelse',
  processing: 'Behandles',
  confirmed: 'Godkendt',
  completed: 'Gennemført',
  voided: 'Annulleret',
};
